import { SnailyError } from './SnailyError'

export class ArgumentNullError extends SnailyError {
	constructor(message: string, metadata?: unknown) {
		super(message, metadata)
		this.name = 'ArgumentNullError'

		if (typeof Error.captureStackTrace === 'function') {
			Error.captureStackTrace(this, ArgumentNullError)
		}
	}
}
